import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        minWidth: '560px',
        padding: '1.5rem'
    },
    detailsBorder: {
        borderTop: `5px solid ${theme?.app.clientTheme.colors.primaryColor ||
        '#375073'}`
    },
    approvalBorder: {
        borderTop: `12px solid ${theme?.app?.applicationColors.successDark ||
        '#5AAC01'}`
    },
    declineBorder: {
        borderTop: `12px solid ${theme?.app?.applicationColors.failureDark ||
        '#AD3D4B'}`
    },
    approvalHeader: {
        alignSelf: 'center' as const,
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.successDark ||
            '#5AAC01'
    },
    declineHeader: {
        alignSelf: 'center' as const,
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.failureDark ||
            '#AD3D4B'
    },
    cancelIcon: {
        position: 'absolute' as const,
        top: 18,
        right: 18
    },
    paperWidthXl: { width: '80%' },
    '@media (max-width: 1360px)': { paperWidthXl: { width: '700px' }}
});